import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const Inventory = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props}>
    <path fill='none' d='M0,0h24v24H0V0z' />
    <path
      className='fill-current'
      d='M20,2H4C3,2,2,2.9,2,4v3c0,0.7,0.4,1.3,1,1.7V20c0,1.1,1.1,2,2,2h14c0.9,0,2-0.9,2-2V8.7c0.6-0.4,1-1,1-1.7V4
	C22,2.9,21,2,20,2z M15,14H9v-2h6V14z M20,7H4V4l16,0V7z'
    />
  </SvgIcon>
);

export const Quiz = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props}>
    <g>
      <path fill='none' d='M0,0h24v24H0V0z' />
    </g>
    <g>
      <g>
        <path className='fill-current' d='M4,6H2v14c0,1.1,0.9,2,2,2h14v-2H4V6z' />
        <path
          className='fill-current'
          d='M20,2H8C6.9,2,6,2.9,6,4v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4C22,2.9,21.1,2,20,2z M14,15
			c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1c0.6,0,1,0.4,1,1C15,14.5,14.6,15,14,15z M16.5,8.8c-0.6,0.9-1.2,1.2-1.6,1.8
			c-0.1,0.2-0.2,0.4-0.2,1.2h-1.5c0-0.4-0.1-1.1,0.3-1.6c0.4-0.7,1.2-1.2,1.6-1.8c0.5-0.7,0.2-1.9-1.1-1.9c-0.9,0-1.3,0.7-1.5,1.2
			l-1.4-0.6C11.5,6,12.5,5,14,5c1.2,0,2.1,0.6,2.5,1.3C16.9,6.9,17.1,8,16.5,8.8z'
        />
      </g>
    </g>
  </SvgIcon>
);

export const BrowseImage = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox='0 0 48 48'>
    <path
      fill='#B4BAC4'
      d='M28.2,0.9h-3.5c-0.2,0-0.5-0.2-0.5-0.5S24.4,0,24.7,0h3.5c0.2,0,0.5,0.2,0.5,0.5
				S28.4,0.9,28.2,0.9z M35.2,0.9h-3.5c-0.2,0-0.5-0.2-0.5-0.5S31.4,0,31.7,0h3.5c0.2,0,0.5,0.2,0.5,0.5S35.4,0.9,35.2,0.9z
				 M41.2,2.9c-0.2,0-0.4-0.1-0.4-0.4c-0.2-1-1.1-1.7-2.1-1.7c-0.2,0-0.5-0.2-0.5-0.5S38.5,0,38.7,0h0c1.4,0,2.6,1,3,2.4
				C41.7,2.6,41.6,2.9,41.2,2.9C41.3,2.9,41.3,2.9,41.2,2.9z M19.1,3.5c-0.2,0-0.5-0.2-0.5-0.4v0c0-1.4,1-2.7,2.4-3
				c0.2-0.1,0.5,0.1,0.5,0.3c0.1,0.2-0.1,0.5-0.3,0.5c-1,0.2-1.7,1.1-1.7,2.1C19.6,3.3,19.4,3.5,19.1,3.5z M41.3,9.9
				c-0.2,0-0.5-0.2-0.5-0.5V6c0-0.2,0.2-0.5,0.5-0.5c0.2,0,0.5,0.2,0.5,0.5v3.5C41.8,9.7,41.6,9.9,41.3,9.9z M19.1,10.5
				c-0.2,0-0.5-0.2-0.5-0.5V6.6c0-0.2,0.2-0.5,0.5-0.5c0.2,0,0.5,0.2,0.5,0.5v3.5C19.6,10.3,19.4,10.5,19.1,10.5z M41.3,16.9
				c-0.2,0-0.5-0.2-0.5-0.5V13c0-0.2,0.2-0.5,0.5-0.5c0.2,0,0.5,0.2,0.5,0.5v3.5C41.8,16.7,41.6,16.9,41.3,16.9z M19.1,17.5
				c-0.2,0-0.5-0.2-0.5-0.5v-3.5c0-0.2,0.2-0.5,0.5-0.5c0.2,0,0.5,0.2,0.5,0.5v3.5C19.6,17.3,19.4,17.5,19.1,17.5z M39.3,23
				c-0.2,0-0.4-0.1-0.4-0.4c-0.1-0.2,0.1-0.5,0.3-0.5c1-0.2,1.7-1.1,1.7-2.1c0-0.2,0.2-0.5,0.5-0.5c0.2,0,0.5,0.2,0.5,0.4v0
				C41.8,21.4,40.8,22.7,39.3,23C39.3,23,39.3,23,39.3,23z M21.7,23.1L21.7,23.1c-1.4,0-2.7-1-3-2.4c-0.1-0.2,0.1-0.5,0.3-0.5
				c0.2-0.1,0.5,0.1,0.5,0.3c0.2,1,1.1,1.7,2.1,1.7c0.2,0,0.5,0.2,0.5,0.5C22.2,22.9,22,23.1,21.7,23.1z M28.8,23.1h-3.5
				c-0.2,0-0.5-0.2-0.5-0.5c0-0.2,0.2-0.5,0.5-0.5h3.5c0.2,0,0.5,0.2,0.5,0.5C29.2,22.9,29,23.1,28.8,23.1z M35.8,23.1h-3.5
				c-0.2,0-0.5-0.2-0.5-0.5c0-0.2,0.2-0.5,0.5-0.5h3.5c0.2,0,0.5,0.2,0.5,0.5C36.2,22.9,36,23.1,35.8,23.1L35.8,23.1z'
    />
    <path
      d='M3.1,9.2c-1.2,0-2.2,1-2.2,2.2l0,17.6c0,1.2,1,2.2,2.2,2.2h17.6c1.2,0,2.2-1,2.2-2.2V11.4
				c0-1.2-1-2.2-2.2-2.2H3.1z M20.7,32.1H3.1c-1.7,0-3.1-1.4-3.1-3.1l0-17.6c0-1.7,1.4-3.1,3.1-3.1h17.6c1.7,0,3.1,1.4,3.1,3.1v17.6
				C23.8,30.7,22.4,32.1,20.7,32.1L20.7,32.1z'
    />
    <path
      fill='#fff'
      d='M23.3,28.9c0,1.5-1.2,2.7-2.7,2.7H3.1c-1.5,0-2.7-1.2-2.7-2.7l0-17.6c0-1.5,1.2-2.7,2.7-2.7
				h17.6c1.5,0,2.7,1.2,2.7,2.7V28.9'
    />
    <path
      fill='#B4BAC4'
      d='M3.1,9.2c-1.2,0-2.2,1-2.2,2.2l0,17.6c0,1.2,1,2.2,2.2,2.2h17.6c1.2,0,2.2-1,2.2-2.2V11.4
				c0-1.2-1-2.2-2.2-2.2H3.1z M20.7,32.1H3.1c-1.7,0-3.1-1.4-3.1-3.1l0-17.6c0-1.7,1.4-3.1,3.1-3.1h17.6c1.7,0,3.1,1.4,3.1,3.1v17.6
				C23.8,30.7,22.4,32.1,20.7,32.1L20.7,32.1z'
    />
    <path
      fill='#fff'
      d='M25.8,31.1l2.9-2.9c0.6-0.6,0.4-1.3-0.4-1.5l-13.4-3.6c-0.8-0.2-1.3,0.3-1.1,1.1l3.6,13.4
				c0.2,0.8,0.9,1,1.5,0.4l2.9-2.9l5.7,5.7c0.6,0.6,1.6,0.6,2.2,0l1.8-1.8c0.6-0.6,0.6-1.6,0-2.2L25.8,31.1'
    />
    <path
      fill='#B4BAC4'
      d='M21.8,34.7c0.1,0,0.2,0,0.3,0.1l5.7,5.7c0.4,0.4,1.2,0.4,1.6,0l1.8-1.8c0.4-0.4,0.4-1.2,0-1.6
				l-5.7-5.7c-0.2-0.2-0.2-0.5,0-0.6l2.9-2.9c0.2-0.2,0.3-0.4,0.2-0.5c0-0.1-0.2-0.2-0.4-0.3l-13.4-3.6c-0.2-0.1-0.4-0.1-0.5,0.1
				c-0.1,0.1-0.1,0.3,0,0.5l3.6,13.4c0,0.1,0.1,0.4,0.4,0.4c0.1,0,0.3-0.1,0.4-0.2l2.9-2.9C21.5,34.8,21.6,34.7,21.8,34.7z
				 M28.5,41.8c-0.5,0-1.1-0.2-1.4-0.6l-5.3-5.3l-2.6,2.6c-0.8,0.8-2,0.5-2.3-0.6l-3.6-13.4c-0.1-0.5-0.1-1,0.2-1.3
				c0.3-0.4,0.9-0.6,1.5-0.4l13.4,3.6c0.6,0.1,1,0.5,1.1,0.9c0.1,0.4,0,0.9-0.5,1.3l-2.6,2.6l5.3,5.3c0.8,0.8,0.8,2.1,0,2.9L30,41.2
				C29.6,41.5,29.1,41.8,28.5,41.8L28.5,41.8z'
    />
    <path
      fill='#B4BAC4'
      d='M6.6,42c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.6l6.4-6.4c0.2-0.2,0.5-0.2,0.6,0
				c0.2,0.2,0.2,0.5,0,0.6l-6.4,6.4C6.8,41.9,6.7,42,6.6,42'
    />
    <path
      fill='#B4BAC4'
      d='M7.3,37.6c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.6l1.8-1.8c0.2-0.2,0.5-0.2,0.6,0
				c0.2,0.2,0.2,0.5,0,0.6l-1.8,1.8C7.5,37.6,7.4,37.6,7.3,37.6'
    />
    <path
      fill='#B4BAC4'
      d='M30.2,13.8c-0.2,0-0.5-0.2-0.5-0.5v-4c0-0.2,0.2-0.5,0.5-0.5c0.2,0,0.5,0.2,0.5,0.5v4
				C30.7,13.6,30.5,13.8,30.2,13.8'
    />
    <path
      fill='#B4BAC4'
      d='M30.2,14.1c-0.1,0-0.2,0-0.3-0.1L28,12.1c-0.2-0.2-0.2-0.5,0-0.6c0.2-0.2,0.5-0.2,0.6,0
				l1.6,1.6l1.6-1.6c0.2-0.2,0.5-0.2,0.6,0c0.2,0.2,0.2,0.5,0,0.6L30.5,14C30.5,14.1,30.3,14.1,30.2,14.1'
    />
  </SvgIcon>
);

export const CheckCircle = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <defs>
        <path
          d='M23,11.1 L23,12 C23,18.1 18.1,23 12,23 C12,23 12,23 12,23 C5.9,23 1,18.1 1,12 C1,5.9 5.9,1 12,1 C12,1 12,1 12,1 C13.5,1 15.1,1.3 16.5,2 C17,2.2 17.2,2.8 17,3.3 C16.8,3.8 16.2,4 15.7,3.8 C14.5,3.3 13.3,3 12,3 C12,3 12,3 12,3 C7,3 3,7 3,12 C3,17 7,21 12,21 C12,21 12,21 12,21 C17,21 21,17 21,12 L21,11.1 C21,10.5 21.4,10.1 22,10.1 C22.6,10.1 23,10.5 23,11.1 Z M23.7,2.3 C23.3,1.9 22.7,1.9 22.3,2.3 L12,12.6 L9.7,10.3 C9.3,9.9 8.7,9.9 8.3,10.3 C7.9,10.7 7.9,11.3 8.3,11.7 L11.3,14.7 C11.5,14.9 11.8,15 12,15 C12.2,15 12.5,14.9 12.7,14.7 L23.7,3.7 C24.1,3.3 24.1,2.7 23.7,2.3 Z'
          id='path-check-circle'
        />
      </defs>
      <g id='34)-icon/check-circle' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <mask id='mask-check-circle' fill='white'>
          <use xlinkHref='#path-check-circle' />
        </mask>
        <use id='Mask' fill='#000000' fillRule='nonzero' xlinkHref='#path-check-circle' />
        <g id='Group' mask='url(#mask-check-circle)' fill={props.htmlColor}>
          <g id='Icon-Color'>
            <rect id='🎨-Icon-Color' x='0' y='0' width='24' height='24' />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const Droplet = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox='0 0 50 50 '>
      <path
        stroke='#e2e2e2'
        strokeWidth={3}
        d='M 25 1.0175781 C 24.71 1.0175781 24.420969 1.1318281 24.230469 1.3613281 C 23.567469 2.1623281 8 21.097047 8 31.998047 C 8 41.373047 15.626 49 25 49 C 34.374 49 42 41.374 42 32 C 42 21.098 26.433484 2.1623281 25.771484 1.3613281 C 25.580984 1.1318281 25.29 1.0175781 25 1.0175781 z M 14 31 C 14.553 31 15 31.448 15 32 C 15 40.606 23.768578 41.956766 24.142578 42.009766 C 24.689578 42.087766 25.068234 42.593625 24.990234 43.140625 C 24.918234 43.639625 24.491953 44 24.001953 44 C 23.954953 44 23.905422 43.997234 23.857422 43.990234 C 23.749422 43.975234 13 42.321 13 32 C 13 31.448 13.447 31 14 31 z'
      />
    </SvgIcon>
  );
};

export const PencilEdit = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <defs>
        <path
          d='M3,18 L7,18 C7.3,18 7.5,17.9 7.7,17.7 L18.7,6.7 C19.1,6.3 19.1,5.7 18.7,5.3 L14.7,1.3 C14.3,0.9 13.7,0.9 13.3,1.3 L2.3,12.3 C2.1,12.5 2,12.7 2,13 L2,17 C2,17.6 2.4,18 3,18 Z M4,13.4 L14,3.4 L16.6,6 L6.6,16 L4,16 L4,13.4 Z M22,22 C22,22.6 21.6,23 21,23 L3,23 C2.4,23 2,22.6 2,22 C2,21.4 2.4,21 3,21 L21,21 C21.6,21 22,21.4 22,22 Z'
          id='path-edit'
        />
      </defs>
      <g id='34)-icon/edit-3' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <mask id='mask-edit' fill='white'>
          <use xlinkHref='#path-edit' />
        </mask>
        <use id='Mask' fill='#000000' fillRule='nonzero' xlinkHref='#path-edit' />
        <g id='Group' mask='url(#mask-edit)' fill={props.htmlColor}>
          <g id='Icon-Color'>
            <rect id='🎨-Icon-Color' x='0' y='0' width='24' height='24' />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const UploadCloud = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <defs>
        <path
          d='M23.7969809,15.6661362 C23.2990611,17.174199 22.3032213,18.4811868 20.9090456,19.2854869 C20.7098777,19.3860245 20.6102937,19.3860245 20.4111257,19.3860245 C20.0127898,19.3860245 19.7140379,19.1849494 19.5148699,18.8833369 C19.216118,18.3806493 19.415286,17.7774241 19.9132058,17.4758116 C20.8094616,16.973124 21.5065495,16.0682863 21.8053014,15.0629111 C22.1040533,14.0575359 22.0044694,12.9516231 21.5065495,12.0467855 C20.8094616,10.7397977 19.5148699,9.93549753 18.0211103,9.93549753 L16.7265186,9.93549753 C16.2285987,9.93549753 15.8302628,9.63388497 15.7306788,9.23173488 C14.7348391,5.51184662 10.950648,3.19948365 7.26604081,4.20485885 C5.47352923,4.60700894 3.97976959,5.71292166 3.0835138,7.32152199 C2.08767403,9.03065984 1.7889221,10.8403352 2.28684198,12.7505481 C2.58559391,13.8564608 3.0835138,14.861836 3.78060163,15.6661362 C4.17893754,16.0682863 4.07935356,16.6715114 3.68101766,17.0736615 C3.28268175,17.4758116 2.68517789,17.3752741 2.28684198,16.973124 C1.39058619,15.8672112 0.693498356,14.660761 0.295162449,13.2532357 C-0.302341411,10.9408727 -0.00358948079,8.52797224 1.29100222,6.41668431 C2.58559391,4.30539638 4.47768947,2.89787109 6.76812093,2.29464596 C11.2493999,1.08819572 15.9298468,3.70217125 17.4236064,8.02528464 L18.0211103,8.02528464 C20.2119578,8.02528464 22.2036373,9.23173488 23.2990611,11.1419478 C23.9961489,12.4489355 24.1953168,14.1580734 23.7969809,15.6661362 Z M12.7431595,11.2424853 C12.6435756,11.1419478 12.5439916,11.0414103 12.4444076,11.0414103 C12.2452396,10.9408727 11.9464877,10.9408727 11.6477358,11.0414103 C11.5481518,11.1419478 11.4485678,11.1419478 11.3489839,11.2424853 L7.36562479,15.2639861 C6.96728888,15.6661362 6.96728888,16.2693613 7.36562479,16.6715114 C7.7639607,17.0736615 8.36146456,17.0736615 8.75980046,16.6715114 L11.0502319,14.3591484 L11.0502319,20.9946248 C11.0502319,21.5978499 11.4485678,22 12.0460717,22 C12.6435756,22 13.0419115,21.5978499 13.0419115,20.9946248 L13.0419115,14.3591484 L15.3323429,16.6715114 C15.5315109,16.8725864 15.8302628,16.973124 16.0294308,16.973124 C16.2285987,16.973124 16.5273506,16.8725864 16.7265186,16.6715114 C17.1248545,16.2693613 17.1248545,15.6661362 16.7265186,15.2639861 L12.7431595,11.2424853 Z'
          id='path-upload-cloud'
        />
      </defs>
      <g id='34)-icon/upload-cloud' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <mask id='mask-upload-cloud' fill='white'>
          <use xlinkHref='#path-upload-cloud' />
        </mask>
        <use id='Mask' fill='#000000' fillRule='nonzero' xlinkHref='#path-upload-cloud' />
        <g id='Group' mask='url(#mask-upload-cloud)' fill={props.htmlColor}>
          <g id='Icon-Color'>
            <rect id='🎨-Icon-Color' x='0' y='0' width='24' height='24' />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const UploadFile = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <defs>
        <path
          d='M22,16.9931741 L22,19.996587 C22,21.698521 20.7,23 19,23 L5,23 C3.3,23 2,21.698521 2,19.996587 L2,16.9931741 C2,16.3924915 2.4,15.9920364 3,15.9920364 C3.6,15.9920364 4,16.3924915 4,16.9931741 L4,19.996587 C4,20.5972696 4.4,20.9977247 5,20.9977247 L19,20.9977247 C19.6,20.9977247 20,20.5972696 20,19.996587 L20,16.9931741 C20,16.3924915 20.4,15.9920364 21,15.9920364 C21.6,15.9920364 22,16.3924915 22,16.9931741 Z M8.7,6.6814562 L11,4.37883959 L11,15.9920364 C11,16.592719 11.4,16.9931741 12,16.9931741 C12.6,16.9931741 13,16.592719 13,15.9920364 L13,4.37883959 L15.3,6.6814562 C15.5,6.88168373 15.7,6.9817975 16,6.9817975 C16.3,6.9817975 16.5,6.88168373 16.7,6.6814562 C17.1,6.28100114 17.1,5.68031854 16.7,5.27986348 L12.7,1.27531286 C12.6,1.17519909 12.5,1.07508532 12.4,1.07508532 C12.2,0.974971559 11.9,0.974971559 11.6,1.07508532 C11.5,1.17519909 11.4,1.17519909 11.3,1.27531286 L7.3,5.27986348 C6.9,5.68031854 6.9,6.28100114 7.3,6.6814562 C7.7,7.08191126 8.3,7.08191126 8.7,6.6814562 Z'
          id='path-upload-file'
        />
      </defs>
      <g id='34)-icon/upload' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <mask id='mask-upload-file' fill='white'>
          <use xlinkHref='#path-upload-file' />
        </mask>
        <use id='Mask' fill='#000000' fillRule='nonzero' xlinkHref='#path-upload-file' />
        <g id='Group' mask='url(#mask-upload-file)' fill='#4B5462'>
          <g id='Icon-Color'>
            <rect id='🎨-Icon-Color' x='0' y='0' width='24' height='24' />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
